import { FeaturedProductCollections } from "../components/blocks/featured-product-collection";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_FeaturedProductCollections";

const create = (data: any): JSX.Element => {
  return <FeaturedProductCollections {...data} />;
};

export default { test, create };
